"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStableMetaPool = exports.isStandardPool = exports.isStablePool = void 0;
const types_1 = require("../types");
const isStandardPool = (pool) => pool.type === types_1.PoolType.STANDARD;
exports.isStandardPool = isStandardPool;
const isStablePool = (pool) => pool.type === types_1.PoolType.STABLE_PLAIN || pool.type === types_1.PoolType.STABLE_META;
exports.isStablePool = isStablePool;
const isStableMetaPool = (pool) => pool.type === types_1.PoolType.STABLE_META;
exports.isStableMetaPool = isStableMetaPool;
//# sourceMappingURL=types.js.map